import { intervalToDuration } from 'date-fns'
import { omit } from 'lodash'

import { getServerDate } from '../../../../../utils/dates'

export const getDuration = (finishDate: Date): Omit<Duration, 'years' | 'weeks'> => {
  const duration = intervalToDuration({ start: getServerDate(), end: finishDate })
  const resultDuration = Object.entries(omit(duration, 'years', 'weeks')).reduce((result, [key, value]) => {
    const parsedValue = getStringValue(value)

    if ((key === 'months' || key === 'days') && value === 0) {
      return result
    }

    return { ...result, [key]: parsedValue }
  }, {})

  return resultDuration
}
function getStringValue(value: number) {
  return value.toString().length === 1 ? `0${value}` : value.toString()
}
